import { api, authHeader } from "../configs/axiosConfigs";

const baseUrl = "/SLN/Management/Reports";

const FollowUpPerformanceReportApi = {
  getFilterData: async () => {
    const response = await api.request({
      url: `${baseUrl}/GetFollowUpPerformanceFilterData`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getReport: async (searchParams) => {
    const response = await api.request({
      url: `${baseUrl}/FollowUpPerformance`,
      method: "POST",
      headers: authHeader(),
      data: searchParams,
    });
    return response.data;
  },
};

export default FollowUpPerformanceReportApi;
